import React from 'react';

import http from 'api/http';
import { boatAPI } from 'api/requests';

import CubicCapacityInput from './CubicCapacityInput';
import ApplicationActions from 'Components/ApplicationActions';
import { CATAMARAN, JON_BOAT } from '../../../../../constants/boatApplication';

class CubicCapacity extends React.Component {
  constructor(props) {
    super(props);

    this.state = props.boat.cubicCapacity;

    this.calculationRequest = [];
    this.calculationRequestIndex = 0;
    this.mainCalculationRequest = [];
    this.mainCalculationRequestIndex = 0;
    this.errors = {};

    this.tableRows = ['a', 'b', 'c', 'd'];
    if (props.boat.boatType !== JON_BOAT && props.boat.boatType !== CATAMARAN) this.tableRows.unshift('beam');
    if (props.boat.boatType !== JON_BOAT) this.tableRows.push('e', 'f');
    if (props.boat.boatType === CATAMARAN) this.tableRows.push('g', 'h');
  }

  validateStep = () => {
    const {isManual, cubicCapacity, isAreas, areas, calculationLength, volumeWithinMotor} = this.state;

    return new Promise((resolve, reject) => {
      if (isManual) {
        if (cubicCapacity) {
          resolve();
        } else {
          this.errors.cubicCapacity = true;
          this.forceUpdate();
          reject();
        }
      } else {
        let stepValid = true;

        if (isAreas) {
          Object.keys(areas).forEach(areaName => {
            if (areas[areaName].area === undefined ||
              areas[areaName].area === '' ||
              areas[areaName].area === null ||
              (this.errors[areaName] && this.errors[areaName].area)) {
              if (!this.errors[areaName]) this.errors[areaName] = {};
              this.errors[areaName].area = this.errors[areaName].area || true;
              stepValid = false;
            }
          });
        } else {
          Object.keys(areas).forEach((areaName) => {
            this.tableRows.forEach((rowName) => {
              if (areas[areaName][rowName] === undefined ||
                areas[areaName][rowName] === '' ||
                areas[areaName][rowName] === null ||
                (this.errors[areaName] && this.errors[areaName][rowName])) {
                if (!this.errors[areaName]) this.errors[areaName] = {};
                this.errors[areaName][rowName] = this.errors[areaName][rowName] || true;
                stepValid = false;
              }
            });
          });
        }

        if (calculationLength === undefined ||
          calculationLength === '' ||
          calculationLength === null ||
          this.errors.calculationLength) {
          this.errors.calculationLength = this.errors.calculationLength || true;
          stepValid = false;
        }

        if (volumeWithinMotor === undefined ||
          volumeWithinMotor === '' ||
          volumeWithinMotor === null ||
          this.errors.volumeWithinMotor) {
          this.errors.volumeWithinMotor = this.errors.volumeWithinMotor || true;
          stepValid = false;
        }

        if (stepValid) {
          resolve();
        } else {
          this.forceUpdate();
          reject();
        }
      }
    });
  };

  isEmptyInputs = () => {
    const {isAreas, areas, calculationLength, volumeWithinMotor} = this.state;

    let emptyInputs = true;

    if (isAreas) {
      Object.keys(areas).forEach(areaName => {
        if (areas[areaName].area === undefined ||
          areas[areaName].area === '' ||
          areas[areaName].area === null ||
          (this.errors[areaName] && this.errors[areaName].area)) emptyInputs = false;
      });
    } else {
      Object.keys(areas).forEach((areaName) => {
        this.tableRows.forEach((rowName) => {
          if (areas[areaName][rowName] === undefined ||
            areas[areaName][rowName] === '' ||
            areas[areaName][rowName] === null ||
            (this.errors[areaName] && this.errors[areaName][rowName])) emptyInputs = false;
        });
      });
    }

    if (calculationLength === undefined ||
      calculationLength === '' ||
      calculationLength === null ||
      this.errors.calculationLength) emptyInputs = false;

    if (volumeWithinMotor === undefined ||
      volumeWithinMotor === '' ||
      volumeWithinMotor === null ||
      this.errors.volumeWithinMotor) emptyInputs = false;

    return emptyInputs;
  };

  handleCapacityInputTypeChange = isManual => () => {
    this.setState({isManual}, () => {
      this.errors = {};
    });
  };

  toggleAreasInput = () => {
    const {markStepAsRedacted} = this.props;

    markStepAsRedacted();
    this.setState(prevState => ({isAreas: !prevState.isAreas}), () => {
      if (!this.state.isAreas) {
        for (let field in this.state.areas) {
          this.areasCalculation(field, this.state.areas, true);
        }
      }
    });
  };

  handleInputChange = targetField => value => {
    const {markStepAsRedacted} = this.props;
    const {isManual} = this.state;

    markStepAsRedacted();
    if (value !== null) {
      if (this.errors[targetField]) delete this.errors[targetField];
      this.setState({[targetField]: value}, () => {if (!isManual) this.mainCalculation();});
    }
  };

  handleAreaChange = columnName => value => {
    const {markStepAsRedacted} = this.props;

    markStepAsRedacted();
    if (value !== null) {
      const cubicCapacityMatrix = {...this.state.areas};
      cubicCapacityMatrix[columnName].area = value;

      if (this.errors[columnName] && this.errors[columnName].area) delete this.errors[columnName].area;

      this.setState({areas: cubicCapacityMatrix}, this.mainCalculation);
    }
  };

  handleMatrixChange = (columnName, rowName) => (value, error) => {
    const {markStepAsRedacted} = this.props;

    markStepAsRedacted();

    if (value === '' || error) {
      if (!this.errors[columnName]) this.errors[columnName] = {};
      this.errors[columnName][rowName] = error || true;
    } else {
      if (this.errors[columnName] && this.errors[columnName][rowName]) delete this.errors[columnName][rowName];
    }

    const cubicCapacityMatrix = {...this.state.areas};
    cubicCapacityMatrix[columnName][rowName] = value;
    this.areasCalculation(columnName, cubicCapacityMatrix);

    this.setState({areas: cubicCapacityMatrix});
  };

  mainCalculation = () => {
    const {volumeWithinMotor, calculationLength, areas} = this.state;
    const {id} = this.props.boat;

    let allEnteredAreas = (function checkAllAreas() {
      let allAreasEntered = {};
      Object.keys(areas).forEach(element => {
        if (areas[element].area) allAreasEntered[element] = areas[element].area;
      });
      return allAreasEntered;
    })();

    if (volumeWithinMotor && calculationLength && Object.keys(allEnteredAreas).length === 5) {
      const index = ++this.mainCalculationRequestIndex;
      http.put(boatAPI.calculateCapacity(id), {
        calculationLength: +calculationLength,
        volumeWithinMotor: +volumeWithinMotor,
        areas: allEnteredAreas
      })
        .then(({data}) => {
          this.mainCalculationRequest[index] = +data.toFixed(2);
          this.setState({cubicCapacity: this.mainCalculationRequest[this.mainCalculationRequest.length - 1]});
        });
    }
  };

  areasCalculation = (type, matrix, isWithoutIndexes) => {
    const {id} = this.props.boat;

    const enteredFields = [];
    Object.keys(matrix[type]).forEach(element => {
      if (element !== 'area' && matrix[type][element]) enteredFields.push(matrix[type][element]);
    });

    const cubicCapacityMatrix = {};
    if (enteredFields.length >= this.tableRows.length) {
      Object.keys(matrix[type]).forEach(element => {
        cubicCapacityMatrix[element] = matrix[type][element] !== '' ? parseFloat(matrix[type][element]) : 0;
      });

      const index = ++this.calculationRequestIndex;
      http.put(boatAPI.checkMatrix(id), {
        type, ...cubicCapacityMatrix
      })
        .then(response => {
          this.calculationRequest[index] = +response.data.toFixed(2);
          this.saveCapacity(type, matrix, isWithoutIndexes ? +response.data.toFixed(2) : this.calculationRequest[this.calculationRequest.length - 1]);
        });
    } else {
      this.saveCapacity(type, matrix, undefined);
    }
  };

  saveCapacity = (type, matrix, data) => {
    if (data === undefined) delete matrix[type].area;
    else matrix[type].area = data;

    this.setState(prevState => ({
      areas: {
        ...prevState.areas,
        [type]: {...matrix[type]}
      }
    }), () => this.mainCalculation());
  };

  sendCapacityToBackEnd = () => {
    const {id} = this.props.boat;
    const {isManual, isAreas, cubicCapacity, areas, calculationLength, volumeWithinMotor} = this.state;

    return new Promise((resolve, reject) => {
      let data = {
        manualCubicCapacity: isManual,
        manualAreas: isAreas,
        boatId: id,
      };

      if (isManual) {
        data.cubicCapacity = parseFloat(cubicCapacity);
      } else {
        if (isAreas) {
          data.areas = [
            ...Object.keys(areas).map(type => ({
              type, area: parseFloat(areas[type].area)
            }))];
        } else {
          let newAreas = areas;
          data.areas = [
            ...Object.keys(newAreas).map(type => {

              Object.keys(newAreas[type]).forEach(element => (
                newAreas[type][element] = parseFloat(newAreas[type][element])
              ));
              delete newAreas[type].type;
              return {
                type, ...newAreas[type]
              };
            })];
        }
        data.calculationLength = calculationLength;
        data.volumeWithinMotor = volumeWithinMotor;
      }

      http.put(boatAPI.saveCubicCapacity, data)
        .then(resolve)
        .catch(reject);
    });

  };

  handleMoveToNextStep = () => {
    const {updateBoatDetails, goToStep} = this.props;

    this.validateStep()
      .then(() => {
        this.sendCapacityToBackEnd()
          .then(() => {
            updateBoatDetails({cubicCapacity: {...this.state}});
            goToStep('next', true);
          });
      });
  };

  handleMoveToArbitraryStep = stepId => {
    const {goToStep, stepIsChanged, updateBoatDetails} = this.props;

    if (!stepIsChanged) {return goToStep(typeof stepId === 'string' ? stepId : 'prev', true);}

    this.validateStep()
      .then(() => {
        this.sendCapacityToBackEnd()
          .then(() => {
            updateBoatDetails({cubicCapacity: {...this.state}});
            goToStep(typeof stepId === 'string' ? stepId : 'prev', true);
          });
      })
      .catch(() => {goToStep(typeof stepId === 'string' ? stepId : 'prev', false);});
  };

  render() {
    const {isManual} = this.state;
    const {getHeader, getNavBar, stepIsChanged, updateBoatDetails, boat} = this.props;

    return (
      <React.Fragment>
        {getHeader(() => {
          return new Promise((resolve, reject) => {
            this.validateStep().then(() => {
              this.sendCapacityToBackEnd();
              updateBoatDetails({ cubicCapacity: { ...this.state } });
              resolve();
            });
          });
        })}

        {getNavBar(this.handleMoveToNextStep, this.handleMoveToArbitraryStep)}

        <section className='scene_section cubic-capacity-input-type-section _border_top_1'>
          <header>Cubic Capacity Input</header>
          <div className='cubic-capacity-type-button-holder'>
            <div className={`${isManual ? 'active' : ''}`} onClick={this.handleCapacityInputTypeChange(true)}>
              Manual
            </div>
            <div className={`${isManual ? '' : 'active'}`} onClick={this.handleCapacityInputTypeChange(false)}>
              Matrix
            </div>
          </div>
          <p>Attention: Future data calculations depend on the selected option.</p>
        </section>

        <CubicCapacityInput
          errors={this.errors}
          areaTypes={this.state.areas}
          tableRows={this.tableRows}
          handleInputChange={this.handleInputChange}
          handleMatrixChange={this.handleMatrixChange}
          toggleAreasInput={this.toggleAreasInput}
          handleAreaChange={this.handleAreaChange}
          isEmptyInputs={this.isEmptyInputs}
          boat={boat}
          {...this.state}
        />

        <ApplicationActions
          backButtonLabel='Prev. Step'
          saveButtonLabel='Next Step'
          saveButtonAction={
            stepIsChanged
              ? this.handleMoveToNextStep
              : () => {
                this.handleMoveToArbitraryStep('next');
              }
          }
          backButtonAction={this.handleMoveToArbitraryStep}
        />
      </React.Fragment>
    );
  }
}

export default CubicCapacity;



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/New/CubicCapacityScene/CubicCapacity.jsx